export function getSvgElement(svgString) {
    return new DOMParser().parseFromString(svgString, "image/svg+xml").documentElement;
}

/**
 * Parse an SVG string and return a styled element ready for use as an icon.
 * Sets display:block and 100% width/height to fill container.
 * @param {string} svgString - Raw SVG markup
 * @returns {SVGElement}
 */
export function getSvgIconElement(svgString) {
    const element = getSvgElement(svgString);
    element.style.cssText = "display:block;height:100%;width:100%;";
    return element;
}